import { useEffect } from "react";
import { injectClientGAData } from "@app/helpers/clientMetadata";
import { GADataProps } from "@components/GAData/GAData";
import { useUserInfo } from "@features/mySph/hooks/useUserInfo";
import useMyBtStore from "@store/useMyBtStore";

type UseInjectClientDataProps = {
  gaProps: GADataProps;
  gaVariant?: string;
};

/**
 * This hook is used to inject client-side GA data and Ad targeting data into the page.
 */
export const useInjectClientData = ({
  gaProps,
  gaVariant,
}: UseInjectClientDataProps) => {
  const { userInfo, visitorId, visitorCat, userType } = useUserInfo();
  const myBTTags = useMyBtStore((store) => store.tags);

  useEffect(() => {
    if (typeof window === "undefined") return;

    injectClientGAData({
      ...gaProps,
      visitorcat: visitorCat,
      abVariant: gaVariant,
      at: visitorId,
      product_flag: myBTTags.length > 0 ? "mybt" : "(not set)",
      user_keyword:
        myBTTags.length > 0
          ? myBTTags.map((tag) => tag.name).join("|")
          : "(not set)",
      svc: userInfo?.serviceFlags?.join("|") || "(not set)",
    });
  }, [userInfo, gaProps, myBTTags, visitorId, visitorCat, gaVariant, userType]);

  return null;
};
